import { render, staticRenderFns } from "./VueObjectView.vue?vue&type=template&id=970aacfe&scoped=true&"
import script from "./VueObjectView.vue?vue&type=script&lang=js&"
export * from "./VueObjectView.vue?vue&type=script&lang=js&"
import style0 from "./VueObjectView.vue?vue&type=style&index=0&id=970aacfe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970aacfe",
  null
  
)

export default component.exports